import axios from "axios";
import { toast } from "react-toastify";
import { handleAuthFailure, isAuthRedirecting } from "./authRedirect";

const API_URL = process.env.REACT_APP_API_URL;
const TOKEN_ERRORS = ["jwt expired", "jwt malformed", "Token missing"];

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.response.use(
  response => response,
  error => {
    if (
      axios.isCancel(error) ||
      error.name === "CanceledError" ||
      error.name === "AbortError"
    ) {
      return new Promise(() => {});
    }

    if (isAuthRedirecting()) {
      return new Promise(() => {});
    }

    const err = error?.response?.data;
    const status = error?.response?.status;
    const isTokenError =
      status === 401 ||
      TOKEN_ERRORS.includes(err?.error);

    const isAccessDenied = status === 403 && !isTokenError;

    if (isTokenError) {
      handleAuthFailure();
      return new Promise(() => {});
    }

    if (isAccessDenied) {
      toast.error(err?.message || "Access denied.");
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data);
}

export async function postFormData(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then(response => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function patchFormData(url, data, config = {}) {
  return axiosApi
    .patch(url, data, { ...config })
    .then(response => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data);
}
